import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { db } from "../../../firebase-config";
import BaseBarChart from "../../../utils/BaseBarChart";

export default function RealGDPGrowthChart() {
    const [countryName, setCountryName] = React.useState("")
    const [data, setData] = React.useState([]);
    const [gdpYears, setGdpYears] = React.useState([]);
    // Loading State
    const [loading, setloading] = React.useState(true);

    async function fetchValues({ country }) {
        const q = query(
            collection(db, "GDP-Growth-Rates"),
            where("country", "==", country),
            orderBy("year")
        )
        const allGDPValues = [];
        const years = [];
        let name;

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            allGDPValues.push(doc.data()["value"]);
            years.push(doc.data()["year"])
            name = doc.data()["country"];
        });
        setData(allGDPValues);
        setCountryName(name);
        setGdpYears(years)
        setloading(false);
    }

    React.useEffect(() => {
        fetchValues({
            country: "Kenya"
        })

    }, []);

    return loading ? (
        <Typography variant="h4" align="center">
            Loading...
        </Typography>
    ) : (
        <>
            <Box sx={{
                m: "5px"
            }}>
                <Typography variant="h5" align="center">
                    {`${countryName}'s GDP Growth Rate`}
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <BaseBarChart
                            name={`${countryName}'s GDP Growth Rate`}
                            data={data}
                            categories={gdpYears}
                        />
                    </Grid>
                </Grid>
            </Box>

        </>
    );
}
